import axios from "axios";

//const
const SHOW_DATABASE_SERVICE_UPDATE_DATA = "showDatabaseService/SHOW_DATABASE_SERVICE_UPDATE_DATA"
const SHOW_DATABASE_SERVICE_TOGGLE_MODAL = "showDatabaseService/SHOW_DATABASE_SERVICE_TOGGLE_MODAL"
const SHOW_DATABASE_SERVICE_TOGGLE_LOADING = "showDatabaseService/SHOW_DATABASE_SERVICE_TOGGLE_LOADING"
const DATABASE_LIST_STORE_SHOW_DATABASENAME = "showDatabaseService/DATABASE_LIST_STORE_SHOW_DATABASENAME"
const DATABASE_RESOURCE_STORE_SHOW_DATABASERESOURCE = "showDatabaseService/DATABASE_RESOURCE_STORE_SHOW_DATABASERESOURCE"
const UPDATE_DATABASE_STORE_SHOW_DATABASENAME = "showDatabaseService/UPDATE_DATABASE_STORE_SHOW_DATABASENAME"

//reducer
export const showDatabaseService = (state = {
  months:1,
  tsDatabaseSize:"",
  currentEnterprise:"",
  databaseNames:[],
  databaseResources:[],
  showDatabases:[],
},action) => {
  switch (action.type) {
    case SHOW_DATABASE_SERVICE_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case SHOW_DATABASE_SERVICE_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case SHOW_DATABASE_SERVICE_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case DATABASE_LIST_STORE_SHOW_DATABASENAME:
      return {
        ...state,
        databaseNames: action.data
      };
    case DATABASE_RESOURCE_STORE_SHOW_DATABASERESOURCE:
      return{
        ...state,
        databaseResources: action.data
      };
    default:
      return state
  }
}
//actions
export const updateData = (data) => {
  return {
    type: SHOW_DATABASE_SERVICE_UPDATE_DATA,
    data: data
  }
}

/**
 * get all databaseNames
 */
export const getDatabaseName = (data) => (dispatch) => {
  dispatch(toggleLoading(true));

  dispatch(updateData({
    name: "enterpriseId",
    value: data.enterpriseId,
  }));
  console.log("----"+data);
  console.log("++++++"+data.enterpriseId);

  axios.get(`/api-tenant/databaseResource/get/databaseResource/${data.enterpriseId}` , {contentType: "application/json"}).then(
      response => {
        console.log(response);
        dispatch(toggleLoading(false));
        if (response.data) {
          dispatch(storeDatabaseResource(response.data));
          dispatch(toggleLoading(false));
          axios.get(`/api-tenant/databaseResource/get/databaseName/${data.enterpriseId}`, {contentType: "application/json"}).then(
            response => {
              console.log(response);
              dispatch(toggleLoading(false));
              if (response.data) {
                dispatch(storeShowDatabase(response.data));
                dispatch(toggleLoading(false));
              }
            }
          )
        }
      }
  );
};

export const toggleModal = (show) => {
  return {
    type: SHOW_DATABASE_SERVICE_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: SHOW_DATABASE_SERVICE_TOGGLE_LOADING,
    data: show
  }
};

export const storeShowDatabase = (databaseNames) => {
  console.log(databaseNames);
  return {
    type: DATABASE_LIST_STORE_SHOW_DATABASENAME,
    data: databaseNames
  }
};

export const storeDatabaseResource = (databaseResources) => {
  return {
    type: DATABASE_RESOURCE_STORE_SHOW_DATABASERESOURCE,
    data: databaseResources
  }
};

export const filterDatabaseName = (data) => (dispatch) => {
  console.log(data);
    let showDatabases = data.databaseNames.filter(value => {
      console.log(value);
      return value.databaseName.indexOf(data.searchName) > -1
    })
    dispatch(storeShowDatabase(showDatabases));
  };


